export enum ApartmentType {
	Apartment = 1,
	Studio = 2,
	Maisonette = 3
}
